import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

// Common components
import Header from "./component/Header.jsx";
import Home from "./component/Home.js"
import Login from "./component/Login.js";
import Register from "./component/Register.js";
import ResumeUpload from "./component/ResumeUpload.js";
import Footer from "./component/Footer.jsx"; 

// Admin components
import AdminJobs from './component/Admin/AdminJobs.js';
import AdminResumes from './component/Admin/AdminResumes.js';

// User components
import UploadResume from './component/User/UploadResume.js';
import Career from './component/Career.js';
import JobApplicationChoice from './component/JobApplicationChoice.js';
import PersonalInfoForm from './component/PersonalInfoForm.js';
import MultiStepForm from './component/MultiStepForm.js';
import Aboutus from './component/Aboutus.js';
import Contactus from './component/Contactus.js';
import SubcategoryPage from "./component/SubcategoryPage.js";
import ScrollToTop from './component/ScrollToTop.js';

function App() {
  const location = useLocation();

  // Define paths where Footer should be visible
  const showFooterRoutes = ['/aboutus', '/careers', '/contact'];
  const shouldShowFooter = showFooterRoutes.includes(location.pathname);

  return (
    <div className="app-container">
      <Header />
      <ScrollToTop/>

      <Routes>
        {/* Common routes */}
        <Route path="/" element={<Home/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/resume" element={<ResumeUpload />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contact" element={<Contactus/>}/>

        {/* Admin routes */}
        <Route path="/admin/jobs" element={<AdminJobs />} />
        <Route path="/admin/resumes" element={<AdminResumes />} />

        {/* User routes */}
        <Route path="/upload" element={<UploadResume />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/signinregister" element={<JobApplicationChoice />} />
        <Route path="/multistep" element={<MultiStepForm />} />
        <Route path="/personalinfo" element={<PersonalInfoForm />} />
        <Route path="/subcategory/:slug" element={<SubcategoryPage/>}/>
      </Routes>

      {/* Footer only for selected routes */}
      {shouldShowFooter && <Footer />}
    </div>
  );
}

export default App;


